/**
 * Decimal, Landin APP;
 * After Login this app will opens
 * Copyright (C) 2008-2013 Decimal
 * mailto:contact AT decimal DOT co DOT in
 *
 * Landing is Decimal software; you can not redistribute it.
 * any versions of the License.
 * License is private by the Decimal Foundation;
 *
 * Inc., 8th Floor, Tower – D, Pioneer Urban Square, Golf Course Ext Rd,
 * Sector 62, Gurugram, Haryana 122102
 */

import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './material/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServicesModule } from './core/services/services.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { OutletComponent } from './components/outlet/outlet.component';
import { LeftSideNavComponent } from './components/left-side-nav/left-side-nav.component';
import { RightSideNavComponent } from './components/right-side-nav/right-side-nav.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { NotificationComponent } from './components/right-side-nav/components/notification/notification.component';
import { SelectWorkspaceComponent } from './components/nav-bar/select-workspace/select-workspace.component';
import { LetterPipe } from './components/nav-bar/pipes/letter.pipe';
import { ApplicationApiListComponent } from './components/right-side-nav/components/application-api-list/application-api-list.component';
import { SwitchWorkspaceWarningPopupComponent } from './components/nav-bar/switch-workspace-warning-popup/switch-workspace-warning-popup.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import { LowResolutionComponent } from './low-resolution/low-resolution.component';

/**
 * NgModule Decorator
 * contains
 * declarations
 * imports
 * providers
 * bootstrap
 */
@NgModule({
  declarations: [
    AppComponent,
    OutletComponent,
    LeftSideNavComponent,
    RightSideNavComponent,
    NavBarComponent,
    NotificationComponent,
    SelectWorkspaceComponent,
    LetterPipe,
    ApplicationApiListComponent,
    SwitchWorkspaceWarningPopupComponent,
    LowResolutionComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    FormsModule,
    MaterialModule,
    BrowserAnimationsModule,
    ServicesModule.forRoot(),
    MarkdownModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})

/**
 * AppModule Class
 * A root module
 */
export class AppModule { }
